<template>
    <section
        class="bg-black-700 full-width relative h-min-screen h-full flex flex-col relative">
        <!--Image Background-->
        <background-image
            :src="sectionContactForm.src"
            :srcset="sectionContactForm.imgSrcSet" />

        <!--Content Layout in a Container-->
        <div class="container z-10 my-14 tablet:flex tablet:my-16 desktop:mt-20">
            <!-- DIV I - Contact Information -->
            <div
                class="contact-info bg-white text-gray-800 py-12 px-8 phone:mb-6 tablet:w-1/2 relative desktop:py-20 desktop:px-16">
                <h3
                    class="uppercase font-bold mb-6 text-xl"
                    v-text="sectionContactForm.contactInfoTitle" />
                <p v-text="sectionContactForm.contactInfoText"></p>
                <br>
                <p
                    class="font-bold"
                    v-text="sectionContactForm.contactInfoCtaText" />
                <hr class="text-gold-500 my-6">
                <div class="flex flex-col">
                    <p
                        class="uppercase font-bold mb-3"
                        v-text="sectionContactForm.estHours" />
                    <p
                        v-if="showLocalTime"
                        class="uppercase text-gold-500 mb-12"
                        v-text="localTime" />
                    <tis-button
                        :url="contactInfo.tollFreePhone | telHref"
                        class="btn-inverted btn-contact block text-sm relative max-w-xs">
                        <svg-icon
                            icon="phone"
                            class="w-7 h-6 inline-block mr-3" />
                        {{ contactInfo.tollFreePhone }}
                        <svg-icon
                            icon="arrow-horizontal"
                            class="w-7 h-6 inline-block ml-3 absolute right-4" />
                    </tis-button>
                    <tis-button
                        :url="'mailto:' + contactInfo.email"
                        class="btn-inverted btn-contact block text-sm relative max-w-xs">
                        <svg-icon
                            icon="email"
                            class="w-7 h-6 inline-block mr-3" />
                        {{ contactInfo.email }}
                        <svg-icon
                            icon="arrow-horizontal"
                            class="w-7 h-6 inline-block ml-3 absolute right-4" />
                    </tis-button>
                    <tis-button
                        :url="route('web.registration')"
                        :full-redirect="true"
                        class="btn-gold btn-contact block text-sm relative max-w-xs">
                        <svg-icon
                            icon="checkmark"
                            class="w-7 h-6 inline-block mr-3" />
                        {{ sectionContactForm.getStartedLabel }}
                        <svg-icon
                            icon="arrow-horizontal"
                            class="w-7 h-6 inline-block ml-3 absolute right-4" />
                    </tis-button>
                </div>
            </div>

            <!-- DIV II - Contact Form -->
            <div class="contact-form bg-white text-gray-800 py-12 px-8 tablet:w-1/2 desktop:py-20 desktop:px-16">
                <h3
                    class="uppercase font-bold text-xl mb-8"
                    v-text="sectionContactForm.contactFormTitle" />
                <contact-form
                    :form-labels="sectionContactForm.contactFormLabels"
                    :post-route="sectionContactForm.postRoute"
                    :contact-form-submitted="sectionContactForm.contactFormSubmitted" />
            </div>
        </div>
    </section>
</template>

<script>
import BackgroundImage from '@web/components/BackgroundImage';
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { toLocalTime, currentTimezoneAbbr, isLocalTimeSameAsEST } from '@whisper/utils/dateTime';
import { sprintf } from '@whisper/utils/string';
import ContactForm from '@whisper/components/contact/ContactForm';
import { telHref } from '@whisper/filters/telHref';

export default {
  components: {
    BackgroundImage,
    TisButton,
    SvgIcon,
    ContactForm,
  },
  filters: {
    telHref,
  },
  props: {
    contactInfo: {
      type: Object,
      required: true,
    },
    sectionContactForm: {
      type: Object,
      required: true,
    },
  },
  data() {
    const showLocalTime = !isLocalTimeSameAsEST(this.sectionContactForm.currentUTCOffset);
    return {
      showLocalTime,
      localTime: showLocalTime ? sprintf(
        this.sectionContactForm.localHours, // "That's %s - %s %s, your timezone."
        toLocalTime(this.sectionContactForm.openIsoTimeStamp),
        toLocalTime(this.sectionContactForm.closeIsoTimeStamp),
        currentTimezoneAbbr(),
      ) : '',
    };
  },
};
</script>

<style scoped>

</style>
